export const redMui = {
  /**
   * Preview: ![red 50](https://mui.com/static/colors-preview/red-50-24x24.png)
   */
  _50: "#ffebee",
  /**
   * Preview: ![red 100](https://mui.com/static/colors-preview/red-100-24x24.png)
   */
  _100: "#ffcdd2",
  /**
   * Preview: ![red 200](https://mui.com/static/colors-preview/red-200-24x24.png)
   */
  _200: "#ef9a9a",
  /**
   * Preview: ![red 300](https://mui.com/static/colors-preview/red-300-24x24.png)
   */
  _300: "#e57373",
  /**
   * Preview: ![red 400](https://mui.com/static/colors-preview/red-400-24x24.png)
   */
  _400: "#ef5350",
  /**
   * Preview: ![red 500](https://mui.com/static/colors-preview/red-500-24x24.png)
   */
  _500: "#f44336",
  /**
   * Preview: ![red 600](https://mui.com/static/colors-preview/red-600-24x24.png)
   */
  _600: "#e53935",
  /**
   * Preview: ![red 700](https://mui.com/static/colors-preview/red-700-24x24.png)
   */
  _700: "#d32f2f",
  /**
   * Preview: ![red 800](https://mui.com/static/colors-preview/red-800-24x24.png)
   */
  _800: "#c62828",
  /**
   * Preview: ![red 900](https://mui.com/static/colors-preview/red-900-24x24.png)
   */
  _900: "#b71c1c",
  /**
   * Preview: ![red A100](https://mui.com/static/colors-preview/red-A100-24x24.png)
   */
  A100: "#ff8a80",
  /**
   * Preview: ![red A200](https://mui.com/static/colors-preview/red-A200-24x24.png)
   */
  A200: "#ff5252",
  /**
   * Preview: ![red A400](https://mui.com/static/colors-preview/red-A400-24x24.png)
   */
  A400: "#ff1744",
  /**
   * Preview: ![red A700](https://mui.com/static/colors-preview/red-A700-24x24.png)
   */
  A700: "#d50000",
};
